"use strict";

export function initInScope ($scope) {
    let modalRequestButton = $scope.find('.js-res-request');
    let paymentSummaryModal = $scope.find('#paymentSummaryModal');
    // TODO CHECK IF STILL NEEDED START

    /* preisberechnung umgebaut auf ajaxform */

    if ((window.matchMedia('(max-width: 991px)').matches)) {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 650) {
                $('.js-objekt-detail-sticky').addClass('is-visible');
                $('footer').css('padding-bottom','6rem');
            } else {
                $('.js-objekt-detail-sticky').removeClass('is-visible');
            }
        });
    }



    /* fehlermeldung wenn keine personen (kundewunsch!!!) */
    // console.log("doing submit handlin");
    // console.log($scope.find('.js-objekt-detail-submit-form'));
    $scope.on('submit', '.js-objekt-detail-submit-form', function (e) {
        if(_config.objectDetailPersonsSelected && !_config.wrongLoginType){

        } else {
            if(_config.wrongLoginType){
                e.preventDefault();
                $('#detailErrorLoginModal').modal('show');
            } else {
                e.preventDefault();
                $('.js-object-detail-persons-error').attr('hidden',false);

                /* mobile sticky button */
                if ((window.matchMedia('(max-width: 767px)').matches)) {
                    let pullup = $scope.find(".portal-search-mobile-pullup");
                    $("body").addClass("modal-open");
                    pullup.addClass("open");
                    if($("#search-fromto").hasClass("show")) {
                        $("#search-fromto").removeClass("show");
                    }
                    // $('html, body').animate({
                    //     scrollTop: $('.js-sticky-box').offset().top - 120
                    // }, 1000);
                }
            }
        }
    });

    if(_config.objectDetailPersonsSelected){
        $('.js-object-detail-persons-error').attr('hidden','hidden')
    }



    /* expose link */
    $scope.find('.js-expose-values').on('click',function (e) {
        e.preventDefault();

        let href = $(this).attr('href');
        let persons = $('.js-expose-input__persons').val();
        let from = $('.js-expose-input__from').val();
        let to = $('.js-expose-input__to').val();


        window.open(href+'?persons='+persons+'&from='+from+'&to='+to, '_blank');
    });
    // TODO CHECK IF STILL NEEDED END

    //new stuff

    let pageUrl   = encodeURIComponent(window.location.href);
    let pageTitle = encodeURIComponent(document.title);
    let pageDesc  = encodeURIComponent($('meta[name="description"]').attr('content') || '');

    $('#shareFacebook').click(e => {
        e.preventDefault();
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
            '_blank','width=600,height=400'
        );
    });

    $('#shareLinkedIn').click(e => {
        e.preventDefault();
        window.open(
            `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`,
            '_blank','width=600,height=500'
        );
    });

    $('#shareWhatsApp').click(e => {
        e.preventDefault();
        window.open(
            `https://api.whatsapp.com/send?text=${pageTitle}%20${pageUrl}`,
            '_blank'
        );
    });
    $('#expose').click(function (e) {
        e.preventDefault();
        var exposeUrl = $(this).attr("href"); // this works now
        // console.log(exposeUrl);
        exposeUrl += window.location.search;
        // console.log(exposeUrl);
        window.open(exposeUrl, '_blank');
    });
    $('#copyLink').click(async function(e) {
        e.preventDefault();
        try {
            await navigator.clipboard.writeText(decodeURIComponent(pageUrl));
            $(this).text('Link copied!').addClass('text-success');
            setTimeout(() => {
                $(this).html('<i class="bi bi-clipboard fs-4 me-2"></i> Copy link')
                    .removeClass('text-success');
            }, 1500);
        } catch {
            alert('Copy failed — please copy manually.');
        }
    });

    $('#sendEmail').click(e => {
        e.preventDefault();
        window.location.href =
            `mailto:?subject=${pageTitle}&body=${pageDesc}%0A%0A${pageUrl}`;
    });
    $(".detail-back-button").on('click', function (e) {
        e.preventDefault();

        const myDomain = window.location.hostname;
        const fallbackUrl = $(this).data("fallback-url");
        const hasHistory     = window.history.length > 1;
        const ref = document.referrer;

        if (!ref || !ref.includes(myDomain) || !hasHistory) {
            window.location.href = fallbackUrl;
        } else {
            history.back();
        }
    });

    modalRequestButton.on('click', function (e) {
        let stickyBox = $scope.find(".js-sticky-box");
        if(! stickyBox.is(':visible')) { //mobile
            stickyBox = $scope.find(".objekt-detail-sticky");
        }
        let bookingButton = stickyBox.find('button[type="submit"]');
        paymentSummaryModal.modal("hide");
        bookingButton.trigger('click');
    });

    if (sessionStorage.getItem('openMessageModal') === "1") {
        sessionStorage.removeItem('openMessageModal');
        $('#messageModal').modal('show');
    }
}